import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdCustomRolesDeleteCustomRoleIdCacheKeys: AllRouteEndpoints[] = [];
